<template>
  <div class="withdrawalSetting">
    <el-dialog v-model="pageData.dialogShow" center title="更改支付宝">
      <div class="dialogView">
        <div class="itemStyleOne">
          <div class="left_">支付宝账户</div>
          <div class="right_">
            <el-input v-model="pageData.changeUser.cashAccount" placeholder="请输入"></el-input>
          </div>
        </div>

        <div class="itemStyleOne">
          <div class="left_">真实姓名</div>
          <div class="right_">
            <el-input v-model="pageData.changeUser.realName" placeholder="请输入"></el-input>
          </div>
        </div>
        <div class="itemStyleOne">
          <div class="left_">手机号码</div>
          <div class="right_">
            <el-input v-model="pageData.changeUser.phone" placeholder="请输入"></el-input>
          </div>
        </div>
        <div class="itemStyleTwo">
          <div class="left_">验证码</div>
          <div class="right_">
            <div class="input_">
              <el-input v-model="pageData.changeUser.verificationCode" placeholder="请输入"></el-input>
            </div>
            <div class="verificationButton" @click="getCode(pageData.changeUser.phone)">
              {{ pageData.show ? "获取验证码" : pageData.count }}
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <div class="dialogButton" @click="withdrawalAddWayFun">确认提现</div>
      </template>
    </el-dialog>

    <div class="titleView">提现管理</div>
    <div class="withdrawaContainer" v-if="pageData.isShow">
      <div class="itemStyleOne">
        <div class="left_">可提现余额</div>
        <div class="right_">
          {{ pageData.withdrawalAmount }}
          <!-- <el-input v-model="pageData" placeholder="请输入"></el-input> -->
        </div>
      </div>

      <div class="itemStyleTwo">
        <div class="left_">到账支付宝</div>
        <div class="right_">
          <div class="input_">{{ pageData.theDetails.cashAccount }}</div>
          <div class="verificationButton" @click="pageData.dialogShow = true">
            修改
          </div>
        </div>
      </div>

      <div class="itemStyleOne">
        <div class="left_">提现金额</div>
        <div class="right_">
          <el-input v-model="pageData.existingData.withdrawalWayCode" placeholder="请输入"></el-input>
        </div>
      </div>
      <div class="itemStyleFour">
        <div class="left_"></div>
        <div class="right_">
          <div class="prompt_">
            提现说明的周期为T+3,提现申请后，3个工作日会到账
          </div>
        </div>
      </div>

      <div class="itemStyleThree">
        <div class="left_"></div>
        <div class="right_">
          <div class="button_" @click="withdraWithdrawalFun">提现</div>
        </div>
      </div>
    </div>

    <div class="settingContainer" v-else>
      <div class="itemStyleOne">
        <div class="left_">可提现余额</div>
        <div class="right_">
          {{ pageData.withdrawalAmount }}
          <!-- <el-input placeholder="请输入"></el-input> -->
        </div>
      </div>

      <div class="itemStyleOne">
        <div class="left_">支付宝账户</div>
        <div class="right_">
          <el-input v-model="pageData.bindingFrom.cashAccount" placeholder="请输入"></el-input>
        </div>
      </div>

      <div class="itemStyleOne">
        <div class="left_">真实姓名</div>
        <div class="right_">
          <el-input v-model="pageData.bindingFrom.realName" placeholder="请输入"></el-input>
        </div>
      </div>
      <div class="itemStyleOne">
        <div class="left_">手机号码</div>
        <div class="right_">
          <el-input v-model="pageData.bindingFrom.phone" placeholder="请输入"></el-input>
        </div>
      </div>
      <div class="itemStyleTwo">
        <div class="left_">验证码</div>
        <div class="right_">
          <div class="input_">
            <el-input v-model="pageData.bindingFrom.verificationCode" placeholder="请输入"></el-input>
          </div>
          <div class="verificationButton" @click="getCode(pageData.bindingFrom.phone)">
            {{ pageData.show ? "获取验证码" : pageData.count }}
          </div>
        </div>
      </div>
      <div class="itemStyleThree">
        <div class="left_"></div>
        <div class="right_">
          <div class="button_" @click="bindingFun">绑定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import {
  withdrawalSelectWayByUserCode,
  smsTemplateSendMsgSecond,
  withdrawalAddWay,
  withdraWithdrawal,
  withdrawalAmount,
} from "../../api/interfaceList";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import { reactive, onMounted, watch, computed } from "vue";
export default {
  name: "withdrawalSetting",
  setup() {
    const router = useRouter();
    let pageData = reactive({
      isShow: true,
      withdrawalAmount: "",
      bindingFrom: {
        cashAccount: '',
        phone: "",
        realName: '',
      },
      existingData: {
        withdrawalWayCode: "",
      },
      changeUser: {
        cashAccount: "",
        phone: "",
        realName: "",
        verificationCode: "",
      },
      theDetails: {
        uniqueCode: '',
        cashAccount: ''
      },
      show: true,
      count: "",
      timer: null,
      dialogShow: false,
    });
    function withdrawalAddWayFun() {
      withdrawalAddWay({
        cashAccount: pageData.changeUser.cashAccount,
        phone: pageData.changeUser.phone,
        realName: pageData.changeUser.realName,
        type: 1,
        uniqueCode: pageData.theDetails.uniqueCode,
        userCode: JSON.parse(Cookies.get("userInformation")).userCode,
        verificationCode: pageData.changeUser.verificationCode,
      }).then((res) => {
        if (res.code == 1) {
          pageData.dialogShow = false;
          withdrawalSelectWayByUserCodeFun();
          ElMessage({
            message: res.message,
            type: "success",
          });
        } else {
          ElMessage.error(res.message);
        }
      });
    }
    let theDialogShow = computed(() => {
      return pageData.dialogShow;
    })
    watch(theDialogShow, () => {
        pageData.changeUser.cashAccount = ''
        pageData.changeUser.phone = ''
        pageData.changeUser.realName = ''
        pageData.changeUser.verificationCode = ''
    });

    function getCode(phone) {
      if (phone) {
        smsTemplateSendMsgSecond({
          phone: phone,
          type: 6,
        }).then((res) => {
          if (res.code == 1) {
            const TIME_COUNT = 60;
            if (!pageData.timer) {
              pageData.count = TIME_COUNT;
              pageData.show = false;
              pageData.timer = setInterval(() => {
                if (pageData.count > 0 && pageData.count <= TIME_COUNT) {
                  pageData.count--;
                } else {
                  pageData.show = true;
                  clearInterval(pageData.timer);
                  pageData.timer = null;
                }
              }, 1000);
            }
          } else {
            ElMessage(res.message);
          }
        });
      } else {
        ElMessage("请输入手机号");
      }
    }

    function withdrawalSelectWayByUserCodeFun() {
      withdrawalSelectWayByUserCode({
        type: 1,
        userCode: JSON.parse(Cookies.get("userInformation")).userCode,
      }).then((res) => {
        if (res.code == 1) {
          if (res.data) {
            pageData.theDetails = res.data;
          } else {
            pageData.isShow = false
          }
        } else {
          ElMessage({
            message: res.message,
          });
        }
      });
    }

    withdrawalAmount({
      usercode: JSON.parse(Cookies.get("userInformation")).userCode,
    }).then((res) => {
      if (res.code == 1) {
        pageData.withdrawalAmount = res.data;
      } else {
        ElMessage({
          message: res.message,
        });
      }
    });
    function withdraWithdrawalFun() {
      if (Number(pageData.withdrawalAmount) >= Number(pageData.existingData.withdrawalWayCode) && Number(pageData.existingData.withdrawalWayCode) > 0) {
        withdraWithdrawal({
          userCode: JSON.parse(Cookies.get("userInformation")).userCode,
          withdrawalAmount: pageData.existingData.withdrawalWayCode,
          withdrawalWayCode: pageData.theDetails.uniqueCode,
        }).then((res) => {
          if (res.code == 1) {
            router.go(-1);
          } else {
            ElMessage({
              message: res.message,
            });
          }
        });
      } else {
        ElMessage({
          message: '请确认可提现的金额',
        });
      }
    }
    function bindingFun() {
      withdrawalAddWay({
        cashAccount: pageData.bindingFrom.cashAccount,
        phone: pageData.bindingFrom.phone,
        realName: pageData.bindingFrom.realName,
        type: 1,
        userCode: JSON.parse(Cookies.get("userInformation")).userCode,
        verificationCode: pageData.bindingFrom.verificationCode,
      }).then((res) => {
        if (res.code == 1) {
          pageData.isShow = true;
          withdrawalSelectWayByUserCodeFun();
          ElMessage({
            message: res.message,
            type: "success",
          });
        } else {
          ElMessage.error(res.message);
        }
      });
    }
    onMounted(() => {
      withdrawalSelectWayByUserCodeFun();
    });
    return {
      pageData,
      getCode,
      withdrawalAddWayFun,
      withdraWithdrawalFun,
      withdrawalSelectWayByUserCodeFun,
      bindingFun
    };
  },
  components: {},
};
</script>
<style lang="scss">
.withdrawalSetting {
  .el-dialog {
    width: 600px;
  }

  .el-dialog__header {
    text-align: left;
    margin: 0;

    .el-dialog__title {
      font-size: 13px;
      font-family: AlibabaPuHuiTiR;
      color: #606266;
    }
  }
}
</style>
<style lang="scss" scope>
.withdrawalSetting {
  width: 1050px;
  padding: 4px 38px 38px 38px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 8px;

  .dialogButton {
    width: 240px;
    height: 40px;
    font-size: 14px;
    font-family: AlibabaPuHuiTiM;
    color: #ffffff;
    line-height: 40px;
    height: 40px;
    background: #008aea;
    border-radius: 8px;
    text-align: center;
    margin: auto;
  }

  .dialogButton:hover {
    background: #6dbbfc;
  }

  .dialogView {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .titleView {
    height: 64px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    font-size: 14px;
    font-family: AlibabaPuHuiTiM;
    color: #909399;
    line-height: 64px;
  }

  .itemStyleFour {
    display: flex;
    align-items: center;

    // margin-top: 20px;
    .left_ {
      width: 63px;
      margin-right: 10px;
    }

    .right_ {
      width: 432px;

      .prompt_ {
        font-size: 12px;
        font-family: AlibabaPuHuiTiR;
        color: #909399;
        margin-top: 8px;
      }
    }
  }

  .itemStyleThree {
    display: flex;
    align-items: center;
    margin-top: 20px;

    .left_ {
      width: 63px;
    }

    .right_ {
      width: 432px;

      .button_ {
        width: 240px;
        height: 40px;
        font-size: 14px;
        font-family: AlibabaPuHuiTiM;
        color: #ffffff;
        line-height: 40px;
        background: #008aea;
        border-radius: 8px;
        text-align: center;
        margin-top: 20px;
        cursor: pointer;
      }

      .button_:hover {
        background: #6dbbfc;
      }
    }
  }

  .itemStyleTwo {
    display: flex;
    align-items: center;
    margin-top: 20px;

    .left_ {
      width: 63px;
      margin-right: 10px;
      font-size: 12px;
      font-family: AlibabaPuHuiTiR;
      color: #303133;
    }

    .right_ {
      width: 432px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 13px;
      font-family: AlibabaPuHuiTiR;
      color: #909399;

      .input_ {
        width: 272px;
      }

      .verificationButton {
        width: 144px;
        height: 40px;
        font-size: 14px;
        font-family: AlibabaPuHuiTiM;
        color: #ffffff;
        line-height: 40px;
        text-align: center;
        background: #008aea;
        border-radius: 8px;
        cursor: pointer;
      }

      .verificationButton:hover {
        background: #6dbbfc;
      }
    }
  }

  .itemStyleOne {
    display: flex;
    align-items: center;
    margin-top: 20px;

    .left_ {
      width: 63px;
      margin-right: 10px;
      font-size: 12px;
      font-family: AlibabaPuHuiTiR;
      color: #303133;
    }

    .right_ {
      width: 432px;
      font-size: 13px;
      font-family: AlibabaPuHuiTiR;
      color: #909399;
    }
  }
}
</style>
